import type React from 'react';

import { Logo } from '@change/ds-core-ui/Logo';

import { parseHtml } from '@change-corgi/core-react/html';

import { CtaButton } from './CtaButton';
import { DefaultContentBlock } from './DefaultContentBlock';
import { C } from './styles';
import type { ActionAlertPreviewData } from './types';

export type { ActionAlertPreviewData } from './types';

// Template reference: https://github.com/change/comms_templates/tree/main/channels/email/templates/aa_sign_ask/sunrise
export const ActionAlertEmailPreview: React.FC<{ data: ActionAlertPreviewData }> = ({ data }) => (
	<div style={{ backgroundColor: C.bodyBg, padding: 16, fontFamily: C.font, color: C.text }}>
		{/* Restore paragraph spacing reset by Tailwind preflight */}
		<style>
			{'.aa-email-preview p { margin-bottom: 0.75em; } .aa-email-preview p:last-child { margin-bottom: 0; }'}
		</style>
		<div
			style={{
				maxWidth: C.innerWidth,
				margin: '0 auto',
				backgroundColor: C.white,
				borderRadius: 4,
				overflow: 'hidden',
			}}
		>
			<div style={{ padding: '20px 24px', textAlign: 'center' }}>
				<Logo color="primary" size="medium" variant="logo" />
			</div>
			<hr style={{ border: 'none', borderTop: `2px solid ${C.border}`, margin: '0 24px' }} />
			<div className="aa-email-preview" style={{ padding: 24 }}>
				{!data.blurbDisabled && (
					<>
						<div style={{ fontSize: 18, lineHeight: 1.5, marginBottom: 16 }}>
							{data.blurb ? (
								parseHtml(data.blurb)
							) : (
								<em style={{ color: C.muted }}>
									[user_preferred_name], you can make a difference. Sign now and help this petition win.
								</em>
							)}
						</div>
						<hr style={{ border: 'none', borderTop: `2px solid ${C.border}`, margin: '16px 0' }} />
					</>
				)}
				{!data.defaultContentBlockDisabled && <DefaultContentBlock data={data} />}
				{(data.contentBlocks ?? []).map((block, i) => (
					<div key={i} style={{ marginTop: 16 }}>
						{block.image && (
							<img src={block.image} alt="" style={{ width: '100%', marginBottom: 12, display: 'block' }} />
						)}
						{block.text && (
							<div style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 12 }}>{parseHtml(block.text)}</div>
						)}
						{block.ctaType && block.ctaType !== 'hidden' && (
							<CtaButton
								type={block.ctaType}
								text={block.ctaText}
								link={block.ctaLink}
								style={block.ctaStyle}
								defaultText="Sign this petition"
							/>
						)}
					</div>
				))}
			</div>
			<div style={{ padding: '16px 24px', borderTop: `1px solid ${C.border}`, textAlign: 'center' }}>
				<p style={{ fontSize: 12, color: C.muted, margin: 0 }}>
					Change.org · 548 Market St #29993, San Francisco, CA 94104
				</p>
			</div>
		</div>
	</div>
);
